import { Auth } from "aws-amplify";
export default {
  namespaced: true,
  state: {
    authUser: null,
  },
  getters: {},
  actions: {
    async fetchAuthUser({ commit }) {
      const user = await Auth.currentAuthenticatedUser();
      commit("setAuthUser", user);
    },
    signOut({ commit }) {
      Auth.signOut().then(() => {
        commit("setAuthUser", null);
      });
    },
  },
  mutations: {
    setAuthUser(state, user) {
      state.authUser = user;
    },
  },
};
